import React from "react";
import "./home.css";
/*import { Footer } from "./components/section";*/
import { BloombergHeader } from "./components/bloombergHeader";

export const Bloomberg = () => {
    return (
        <main className="px-8 py-16 max-w-4xl mx-auto">
            <BloombergHeader/>

            <div className="p-5">
                <h1 className="mb-4 text-start">
                    <strong>Vinformatix Partners to Deliver Open, Transparent Government</strong>
                </h1>
                <i><h2 className="mb-4 text-start">
                    here & now&copy; Platform Recognized by Bloomberg Center for Government Excellence
                </h2></i>

                <p className="text-start" style={{ fontSize: "1.5rem" }}>
                    <b>Baton Rouge, LA - March 15, 2024 -</b> In honor of Sunshine Week, <a href="https://govex.jhu.edu/" target="_blank">Bloomberg Center for
                        Government Excellence (GovEx)</a> recognized Baton Rouge's recently launched app, MyBR,
                    and celebrated the innovation for providing accessibility and transparency for
                    citizens. Vinformatix collaborated with Mayor-President Sharon Weston Broome and her
                    administration to develop MyBR to deliver unprecedented access to essential
                    information and services to Baton Rouge's citizens via their mobile devices.
                </p>

                <p className="mb-4 text-start" style={{ fontSize: "1.5rem" }}>
                    Mayor-President Broome announced the recognition in a press release stating, "We
                    are honored to be acknowledged in this way and remain dedicated to improving our
                    residents' quality of life by making government data and services more accessible
                    and transparent." In her release, Mayor Broome explained the MyBR app simplifies
                    daily tasks for Baton Rouge citizens, including paying parking tickets and water
                    bills, checking road closures, and discovering local arts and entertainment. The
                    app's features also allow users to view local statistics, municipal services, and
                    property records at their fingertips. In conclusion, Mayor Broome extended her
                    gratitude to Vinformatix in developing the MyBR app and reiterated her commitment
                    to innovative, data-driven solutions for enhancing resident services.
                </p>

                <p className="mb-4" style={{ fontSize: "1.5rem" }}>
                    The MyBR app is available for download on both the Apple Store and Google Play
                    Store.
                </p>

                <p className="mb-4" style={{ fontSize: "1.5rem" }}>
                    In pursuit of their mission to help governments use data to make informed decisions
                    and improve people's quality of life, GovEx applauded the work of Mayor Broome's
                    administration for providing citizens with easy access to data directly in the
                    hands of residents through the MyBR app.
                </p>

                <p className="mb-4" style={{ fontSize: "1.5rem" }}>Read Mayor Broome's full press release <a href="https://www.brla.gov/CivicAlerts.aspx?AID=1303" target="_blank">here</a>.</p>

                <p className="mb-4" style={{ fontSize: "1.5rem" }}>Read GovEx's recognition' <a href="https://www.linkedin.com/feed/update/urn:li:activity:7174136154064068610/" target="_blank">here</a>.</p>
            </div>


           {/* <Footer/>*/}
        </main>
    );
};